
/*document.addEventListener('DOMContentLoaded', () => {
  const videoElement = document.querySelector('#myVideo');
  const playPauseButton = document.querySelector('.video-control');

  if (!videoElement || !playPauseButton) return;

  playPauseButton.addEventListener('click', () => {
    playPauseButton.classList.toggle('playing');

    if (videoElement.paused) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
  });

  videoElement.addEventListener('ended', () => {
    playPauseButton.classList.remove('playing');
  });
});*/



/*
 $('.rc_block__type').on('click', function () {
var rcprice = $(this).find('.rc_price').html();    
   $('.product-form__submit span i').html(rcprice);
  });*/

setTimeout(function() {
$('.rc-radio__label').on('click', function () {
     var rcprice = $(this).find('.rc-radio__price').html();        
     $('.product-form__submit span i').html(rcprice);
      console.log('testingsss')
  });
 }, 2000);